/**
 * Page Transparent Header
 * Handles content positioning for pages with transparent header enabled via metafield
 */

(() => {
  // Check if transparent header is enabled on this page
  const isTransparentHeaderEnabled = () => {
    const bodyEnabled = document.body.classList.contains('page-transparent-header');
    const pageHeaderEl = document.querySelector('page-header');
    const headerTransparentAttr = pageHeaderEl && pageHeaderEl.dataset.transparent === 'true';
    const headerTransparentClass = !!document.querySelector('.wt-header--transparent');
    return bodyEnabled || headerTransparentAttr || headerTransparentClass;
  };

  // Check if the header has transparent attribute
  const isHeaderTransparent = () => {
    const header = document.querySelector('page-header');
    return header && header.dataset.transparent === 'true';
  };

  // Calculate the offset needed for negative margin
  const calculateOffset = () => {
    // Header section height
    const headerSection = document.querySelector('header.page-header');
    const headerHeight = headerSection ? headerSection.offsetHeight : 0;

    // Announcement bar section height (if visible)
    const announcementSection = document.getElementById('shopify-section-announcement-bar');
    const announcementVisible = announcementSection && getComputedStyle(announcementSection).display !== 'none';
    const announcementHeight = announcementVisible ? announcementSection.offsetHeight : 0;

    return headerHeight + announcementHeight;
  };

  // Apply negative margin to main content to pull it under the header
  const setContentMargin = () => {
    const mainContent = document.querySelector('main#root');
    
    if (!mainContent) {
      console.warn('[TransparentHeader] Main content element not found');
      return;
    }

    const transparentEnabled = isTransparentHeaderEnabled();
    const headerTransparent = isHeaderTransparent();
    
    console.log('[TransparentHeader] Setting margin...', { transparentEnabled, headerTransparent });

    if (transparentEnabled) {
      const offset = calculateOffset();
      console.log('[TransparentHeader] Applying offset:', offset + 'px');
      // Expose variable for CSS fallback
      mainContent.style.setProperty('--transparent-header-offset', `${offset}px`);
      // Apply inline styles for maximum reliability
      mainContent.style.setProperty('margin-top', `-${offset}px`, 'important');
      // Do NOT add padding-top; we want content to sit under the transparent header
      mainContent.style.removeProperty('padding-top');
    } else {
      console.log('[TransparentHeader] Resetting margin');
      // Reset if not enabled
      mainContent.style.removeProperty('margin-top');
      mainContent.style.removeProperty('padding-top');
      mainContent.style.removeProperty('--transparent-header-offset');
    }
  };

  // Initialize on DOM ready
  const init = () => {
    if (!isTransparentHeaderEnabled()) {
      console.log('[TransparentHeader] Not enabled on this page');
      return;
    }

    console.log('[TransparentHeader] Initializing...');
    
    // Set initial margin
    setContentMargin();

    // Recalculate on window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        setContentMargin();
      }, 100);
    });

    // Watch for header section changes
    const headerSection = document.querySelector('header.page-header');
    if (headerSection) {
      const observer = new MutationObserver(() => setContentMargin());
      observer.observe(headerSection, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    // Watch for announcement bar visibility/size changes
    const announcementSection = document.getElementById('shopify-section-announcement-bar');
    if (announcementSection) {
      const annObserver = new MutationObserver(() => setContentMargin());
      annObserver.observe(announcementSection, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
  };

  // Wait for both DOM and all resources to be ready
  const waitForElements = () => {
    const checkElements = () => {
      const mainContent = document.querySelector('main#root');
      const headerGroup = document.querySelector('header.page-header');
      const pageHeader = document.querySelector('page-header');
      
      if (mainContent && headerGroup && pageHeader) {
        console.log('[TransparentHeader] All elements found, initializing...');
        init();
      } else {
        console.log('[TransparentHeader] Waiting for elements...', { mainContent: !!mainContent, headerGroup: !!headerGroup, pageHeader: !!pageHeader });
        setTimeout(checkElements, 100);
      }
    };
    
    checkElements();
  };

  // Start after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForElements);
  } else {
    waitForElements();
  }
})();
